<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Skill"
      text="Edit Skill"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localSkill.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            <v-col cols="12">
              <v-select                
                ref="category"
                v-model="localSkill.skill_category_id"
                v-validate="'required'"
                :error-messages="errors.collect('skill_category_id')"
                :items="categories"
                data-vv-name="skill_category_id"
                data-vv-as="category"
                item-text="name"
                item-value="id"
                label="Category"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      skill: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localSkill: null,
        categories: [],
      }
    },
    computed: {
      isNameChanged () {
        return this.localSkill.name !== this.skill.name
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.localSkill = { ...this.skill }
      
        this.$api.skillCategories().list()
          .then(response => {
            this.categories = response.data
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.skills().update(this.skill.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        let data = { skill_category_id: this.localSkill.skill_category_id }
      
        if (this.isNameChanged) {
          data['name'] = this.localSkill.name
        }

        return data
      },
    },
  }
</script>
